// src/Pages/ClientMaster.jsx
import { colors as themeColors } from '../utils/theme';
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import CitySearchInput from "../components/CitySearchInput";
import { CameraEnhanceOutlined, Close } from "@mui/icons-material";
import OCRImageCapture from "../components/OCRImageCapture";
import OCRTextAssignment from "../components/OCRTextAssignment";
import { FaFileExcel } from 'react-icons/fa';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { useAuth } from '../context/AuthContext';
import { useRights } from '../context/RightsContext';
import { Box, Typography, TextField, Button, CircularProgress, Paper, InputAdornment, IconButton, Dialog, DialogContent, DialogTitle, DialogActions, Select, MenuItem, FormControl, InputLabel, Snackbar, Alert, Tooltip, Divider, Collapse } from "@mui/material";
import { Grid, useMediaQuery, useTheme } from "@mui/system";
import { toProperCase } from "../utils/formatRows";
import ConsigneeMaster from "./ConsigneeMaster";
import ClientConsigneeMaster from "./ClientConsigneeMaster";
import PartyWiseItemDialog from "./PartyWiseItemDialog";
import GroupWiseDiscMaster from "./GroupWiseDiscMaster";
import DropdownProductCodeClientMaster from "../components/DropdownProductCodeClientMaster";
import Dropdown from "../components/Dropdown";
import AccGroupSelect from "../components/AccGroupSelect";
import AccGrpMaster from "./AccGrpMaster";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getCurrentFYear } from '../utils/financialYear';

export default function ClientMaster({ mode, onPopupCancel, connectionString }) {
    const { user, selectedCompany, loading } = useAuth();
    const { canAccess, showAccessDenied } = useRights() || {};
    const { id } = useParams(); // if mode === "edit", id is the client ID to load
    const navigate = useNavigate();
    const path = connectionString;
    const companyId = selectedCompany?.CompId || null;
    const AppRegID = selectedCompany?.AppRegID || null;
    const fYear = getCurrentFYear();
    const userId = user?.UserId || null;
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
    const theme = useTheme()
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));
    // ──────────────── FORM STATE ────────────────
    const [gstNo, setGstNo] = useState("");
    const [gstError, setGstError] = useState("");
    const [gstValid, setGstValid] = useState(null); // null = untested, true = valid, false = invalid
    const [gstLookupLoading, setGstLookupLoading] = useState(false);
    // NEW: clientCategory dropdown state
    const [clientCategory, setClientCategory] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [address, setAddress] = useState("");
    const [area, setArea] = useState("");
    const [areaError, setAreaError] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [pinCodeError, setPinCodeError] = useState("");
    // For state selection, we’ll use MUI Autocomplete:
    const [stateValue, setStateValue] = useState(null); // { stateName, stateCode }
    const [stateInputValue, setStateInputValue] = useState("");
    const [city, setCity] = useState("");
    const [cityError, setCityError] = useState("");
    const [stateField, setStateField] = useState("");
    const [stateCode, setStateCode] = useState("");
    const [stateError, setStateError] = useState("");
    const [stateCodeError, setStateCodeError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [cities, setCities] = useState([]);
    const [country, setCountry] = useState("");
    const [distance, setDistance] = useState("");
    const [distanceError, setDistanceError] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [alternateMobileError, setAlternateMobileError] = useState("");
    const [alternateMobile, setAlternateMobile] = useState("");
    const [emailId, setEmailId] = useState("");
    const [emailIdError, setEmailIdError] = useState("");
    const [alternateEmailId, setAlternateEmailId] = useState('');
    const [alternateEmailIdError, setAlternateEmailIdError] = useState("");
    const [website, setWebsite] = useState("");
    const [websiteError, setWebsiteError] = useState("");
    const [panNo, setPanNo] = useState("");
    const [panError, setPanError] = useState("");
    const [aadharNo, setAadharNo] = useState("");
    const [aadharError, setAadharError] = useState("");
    const [transporter, setTransporter] = useState("");
    const [agentName, setAgentName] = useState("");
    const [agentComm, setAgentComm] = useState("");
    const [agentCommError, setAgentCommError] = useState("");
    const [msmeNo, setMsmeNo] = useState("");
    const [msmeError, setMsmeError] = useState(""); // if you want to validate format
    const [formError, setFormError] = useState("");
    const [paymentTerms, setPaymentTerms] = useState("");
    const [creditLimit, setCreditLimit] = useState("");
    const [interest, setInterest] = useState("");
    const [disc, setDisc] = useState("");
    const [disc1, setDisc1] = useState("");
    const [disc2, setDisc2] = useState("");
    const [opBal, setOpBal] = useState("");
    // Popup state
    const [openPopup, setOpenPopup] = useState(false);
    const [openCamera, setOpenCamera] = useState(false);
    const [extractedTextLines, setExtractedTextLines] = useState([]);
    const [businessCardData, setBusinessCardData] = useState({ companyName: "", contactPersonName1: "", contactPersonName2: "", mobileNumber1: "", mobileNumber2: "", email1: "", email2: "", websiteUrl: "", address: "", pincode: "" });
    const [isProcessing, setIsProcessing] = useState(false);
    const [gstStatus, setGstStatus] = useState("");   // 👈 add this
    const [cityValidationStatus, setCityValidationStatus] = useState({ isValid: true, missingCityState: null, message: "" });
    const [forceShowCityDropdown, setForceShowCityDropdown] = useState(false);

    const [accGroups, setAccGroups] = useState([]);
    const [selectedAccGrpId, setSelectedAccGrpId] = useState('');
    const [selectedAccGrpName, setSelectedAccGrpName] = useState('');
    const [openAccGrpPopup, setOpenAccGrpPopup] = useState(false);
    const [isLoadingAccGrp, setIsLoadingAccGrp] = useState(false);
    const [accUnderGroup, setAccUnderGroup] = useState([]);

    const EMAIL_SUGGESTIONS = ['nomail@gmail.com',];
    const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);
    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };
    const VALIDATION_ERROR = "VALIDATION_ERROR";
    const [category, setCategory] = useState(0);
    const categoryOptions = [{ id: 0, value: "---NONE---" }, { id: 1, value: "LOCAL" }, { id: 2, value: "INTER-STATE" }, { id: 3, value: "BANK/CASH/REGISTER" }, { id: 6, value: "CGST" }, { id: 7, value: "SGST" }, { id: 8, value: "IGST" }, { id: 9, value: "UTGST" }, { id: 10, value: "CESS" }, { id: 11, value: "RoundOff" }, { id: 12, value: "RCM CGST" }, { id: 13, value: "RCM SGST" }, { id: 14, value: "RCM IGST" }, { id: 15, value: "RCM UTGST" }, { id: 16, value: "RCM GSTCESS" }, { id: 17, value: "AGENT" }, { id: 18, value: "TCS" }, { id: 19, value: "TDS" }];
    const [Errorcategory, setcategoryError] = useState("");
    const [tempConsignees, setTempConsignees] = useState([]);
    const [tempPartyWiseItems, setTempPartyWiseItems] = useState([]);
    const [tempGroupWiseItems, setTempGroupWiseItems] = useState([]);
    const [isFinalSubmitting, setIsFinalSubmitting] = useState(false);
    const [gstDuplicateConfirmOpen, setGstDuplicateConfirmOpen] = useState(false);
    const [activeView, setActiveView] = useState("CLIENT");
    const [showConsignee, setShowConsignee] = useState(false);
    const [accGrpError, setAccGrpError] = useState("");
    const [isCategoryDuplicate, setIsCategoryDuplicate] = useState(false);
    const [openPartyWiseDialog, setOpenPartyWiseDialog] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showGroupWiseDisc, setShowGroupWiseDisc] = useState(false);

    // "CLIENT" | "CONSIGNEE"
    // ──────────────── CLIENT CATEGORY OPTIONS ────────────────
    const clientCategoryOptions = [{ display: "Bank Receipt", value: "Br" }, { display: "Cash Receipt", value: "Cr" }];
    // ──────────────── EFFECT: Fetch “states” for Autocomplete ────────────────
    useEffect(() => {
        let isMounted = true;
        async function Fn_FetchStates() {
            try {
                const res = await axios.get(`${path}/api/get-cities`);
                if (isMounted) setCities(res.data.cities || []);
            } catch {
                // cities unavailable — city validation will be skipped
            }
        }
        Fn_FetchStates();
        return () => { isMounted = false; };
    }, []);

    // Op. Bal. is disabled until an Account Group is selected, and is enabled
    // only when the selected group has GrpHead = 3.
    const isGrpHeadThree = (groupId) => {
        const grp = accGroups.find(g => String(g.AccGrpID) === String(groupId));
        return !!grp && String(grp.GrpHead).trim() === '3';
    };
    const isOpBalDisabled = !selectedAccGrpId || !isGrpHeadThree(selectedAccGrpId);

    const Hlp_Fn_AccUnderGroup = async () => {
        try {
            const { data } = await axios.get(`${path}/api/client-get-data/api/AccUnderGroup`, { params: { companyId }, headers: { "Cache-Control": "no-cache" } });

            // Remap display label: SubGrpName[GrpName] instead of GrpName[SubGrpName]
            const remapped = (data || []).map(item => ({
                ...item,
                displayLabel: `${item.SubGrpName || item.AccGroupName || ''}[${item.GrpName || item.GroupName || ''}]`
            }));

            setAccGroups(remapped || []);
        } catch (err) {
            if (err?.response?.status === 404) {
                setAccGroups([]);
            } else {
                console.error(err);
            }
        }
    };

    useEffect(() => {
        if (companyId) {
            Hlp_Fn_AccUnderGroup();
        }
    }, [companyId]);

    // ──────────────── EFFECT: If mode === "edit", load existing client data ────────────────
    useEffect(() => {
        if (mode === "edit" && id) {
            let isMounted = true;
            async function fetchClient() {
                try {
                    const response = await axios.get(`${path}/client/getDetails/${id}`);
                    const data = response.data;
                    if (!isMounted) return;
                    // Populate fields from returned data
                    const loadedGstNo = data.GSTNo || "";
                    setGstNo(loadedGstNo);
                    // Edit mode loads GSTNo directly (not typed), so the onChange handler
                    // that normally sets gstValid never fires — leaving it at its initial
                    // `null`, which made the Verify button refuse to run (see "Invalid GST
                    // format") even on an unchanged, correctly-saved GST number. Run the
                    // same format check here so Verify works right after loading too.
                    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                    if (!loadedGstNo) {
                        setGstValid(null);
                    } else if (!gstRegex.test(loadedGstNo)) {
                        setGstValid(false);
                    } else {
                        setGstValid(true);
                    }
                    setCompanyName(data.FirmName || "");
                    setClientCategory(data.ClientCategory)
                    setClientCode(data.ClientCode || "");
                    setSelectedAccGrpId(String(data.AccGrpID || ''));
                    setSelectedAccGrpName(String(data.AccGroupName || ''));
                    setAddress(data.Address || "");
                    setArea(data.Area || "");
                    setPinCode(data.Pincode || "");
                    setCity(data.City || "");
                    setCategory(data.Categoryid);
                    // after you do:
                    setAlternateMobile(data.AlternateMobile || "");
                    setEmailId(data.EmailId || "");
                    // add these two:
                    setAlternateEmailId(data.AlternateEmailId || "");
                    setCreditLimit(data.CreditLimit != null ? String(data.CreditLimit) : "");
                    // if you also want payment terms and client‐category in edit:
                    setPaymentTerms(data.PaymentTerm != null ? String(data.PaymentTerm) : "");
                    // setClientCategory(data.clientCategory || "");
                    if (data.state && data.StateCode) {
                        setStateField(data.state);        // 🔥 THIS drives the State textbox
                        setStateCode(data.StateCode);     // 🔥 THIS drives the State Code textbox
                        setCountry(data.Country || "");
                    }
                    setCountry(data.Country || "");
                    setDistance(data.Distance || "");
                    setContactPerson(data.ContactPerson || "");
                    setMobileNo(data.MobileNo || "");
                    // setAlternateMobile(data.alternateMobile || "");
                    // setEmailId(data.emailId || "");
                    // setAlternateEmailId(data.alternateEmailId || "");
                    setWebsite(data.Website || "");
                    setPanNo(data.PANNO || "");
                    setAadharNo(data.AdharNo || "");
                    setTransporter(data.Transporter || "");
                    setAgentName(data.AgentName || "");
                    setAgentComm(data.AgentComm || "");
                    setMsmeNo(data.MSMENo || "");
                    setInterest(data.Interst || "");
                    setDisc(data.Disc || "");
                    setDisc1(data.Disc1 || "");
                    setDisc2(data.Disc2 || "");
                    setOpBal(data.OPBAL != null ? String(data.OPBAL) : "");
                } catch (err) {
                    console.error("Error fetching client details:", err);
                }
            }
            fetchClient();
            return () => { isMounted = false; };
        }
    }, [mode, id]);

    const handleGstAutoFill = async () => {
        if (gstNo.length !== 15) {
            setSnackbar({ open: true, message: "Please enter a valid 15-character GST No", severity: "error" });
            return;
        }

        if (!gstValid) {
            setSnackbar({ open: true, message: "Invalid GST format", severity: "error" });
            return;
        }

        try {
            setGstLookupLoading(true);
            const gstRes = await axios.get(`${path}/api/gst-lookup`, { params: { searchGstin: gstNo }, });
            const d = gstRes.data.data || {};
            let stateCode = gstNo.slice(0, 2);
            console.log(d)

            setGstStatus(d.status || "");

            // fill the "client master" fields from returned data
            setCompanyName(d.clientName || "");
            setContactPerson(d.contactPerson || "");
            setAddress(d.address || "");
            setCity(d.city || "");
            setMobileNo(d.mobileNo || "");
            setEmailId(d.emailId || "");
            setPinCode(d.PinCode ? String(d.PinCode) : "");
            setCountry(d.Country || "");
            setArea(d.Area || d.landMark || d.street || "");
            setStateField(d.state || "");
            setStateCode(d.stateCode || gstNo.slice(0, 2));

            // Check if city exists in database
            const cityExists = cities.find(c => c.city?.toLowerCase() === (d.city || "").toLowerCase() && c.state?.toLowerCase() === (d.state || "").toLowerCase());

            if (!cityExists && d.city && d.state) {
                // City NOT found - force dropdown to open
                setCityValidationStatus({ isValid: false, missingCityState: { city: d.city, state: d.state }, message: `"${d.city}, ${d.state}" not found in database. Please add it first.` });
                setForceShowCityDropdown(true);  // ⭐ FORCE DROPDOWN OPEN
            } else {
                // City found - clear warning
                setCityValidationStatus({ isValid: true, missingCityState: null, message: "" });
                setForceShowCityDropdown(false);
            }

            // Auto-select category based on state match
            const companyState = selectedCompany?.State?.trim().toLowerCase();
            const clientState = (d.state || "").trim().toLowerCase();

            if (companyState && clientState) {
                if (companyState === clientState) {
                    setCategory(1); // LOCAL
                } else {
                    setCategory(2); // INTER-STATE
                }
            } else {
                setCategory(0); // ---NONE--- if state data missing
            }

            setSnackbar({ open: true, message: "GST details fetched successfully", severity: "success" });
        } catch (gstErr) {
            setGstValid(false);
            setGstStatus("");
            if (gstErr.response?.status === 400) {
                setSnackbar({ open: true, message: gstErr.response.data?.message || "GST lookup failed", severity: "error" });
            } else if (gstErr.response?.status === 403) {
                setSnackbar({ open: true, message: "GST is not Active", severity: "error" });
            } else {
                setSnackbar({ open: true, message: "Unable to fetch details for given GST No.", severity: "error" });
            }
            setGstError(gstErr.response?.data?.message || "Unable to fetch details for given GST No.");
            setContactPerson("");
            setAddress("");
            setCity("");
            setStateField("");
            setStateCode("");
        } finally {
            setGstLookupLoading(false);
        }
    };

    // ──────────────── FORM RESET / CANCEL ────────────────
    const Fn_HandleReset = () => {
        if (onPopupCancel) {
            onPopupCancel();
            return;
        }
        // Otherwise, clear all fields and navigate back to “/main”
        setGstNo("");
        setGstError("");
        setGstValid(null);
        setClientCategory("");
        setCompanyName("");
        setClientCode("");
        setAddress("");
        setArea("");
        setPinCode("");
        setPinCodeError("");
        setCity("");
        setStateValue(null);
        setStateInputValue("");
        setCountry("");
        setDistance("");
        setDistanceError("");
        setContactPerson("");
        setMobileNo("");
        setAlternateMobile("");
        setMobileError("");
        setAlternateMobileError("");
        setEmailId("");
        setEmailIdError("");
        setWebsite("");
        setWebsiteError("");
        setPanNo("");
        setPanError("");
        setAadharNo("");
        setAadharError("");
        setTransporter("");
        setAgentName("");
        setAgentComm("");
        setAgentCommError("");
        setMsmeNo("");
        setFormError("");
        setFormError("");
    };
    // ──────────────── FORM SUBMIT ────────────────
    const Fn_HandleSubmit = async (e) => {
        e?.preventDefault?.();
        // Required fields check
        if (!companyName) {
            setFormError("Company Name is required.");
            throw new Error(VALIDATION_ERROR);
        }

        if (!selectedAccGrpId) {
            setFormError("Account Group is required.");
            setAccGrpError("Account Group is required.");
            throw new Error(VALIDATION_ERROR);
        }

        if (!cityValidationStatus.isValid) {
            setFormError("Please add the missing city to database before saving.");
            throw new Error(VALIDATION_ERROR);
        }

        const clientCategoryValue = clientCategory;

        // Build payload (including loggedInUser’s userId)
        console.log(">>>> payload category:", category);
        const opBalValue = parseFloat(opBal) || 0;
        const payload = { gstNo, companyName, clientCode, clientCategory: clientCategory || "", categoryId: category, address, area, pinCode, city, state: stateField || "", stateCode: stateCode || "", country, distance: distance === "" ? 0 : parseFloat(distance), contactPerson, mobileNo, alternateMobile, emailId, alternateEmailId, website, panNo, aadharNo, transporter, agentName, agentComm, msmeNo, paymentTerms: paymentTerms === "" ? 0 : paymentTerms, creditLimit: creditLimit === "" ? 0 : creditLimit, interest: parseFloat(interest) || 0, disc: parseFloat(disc) || 0, disc1: parseFloat(disc1) || 0, disc2: parseFloat(disc2) || 0, opBal: opBalValue, companyId, AppRegID, fYear, userId, accGroupId: selectedAccGrpId || null, accGroupName: selectedAccGrpName || "" };
        // alert(mode);
        try {
            console.log(payload);
            // return;
            if (mode === "add") {
                const res = await axios.post(`${path}/client/insert`, payload);
                const newClientId = res.data?.insertedId || res.data?.id || res.data?.ClientID;
                if (!newClientId) {
                    throw new Error("Client inserted but ID not returned");
                }
                console.log("newClientId", res.data)
                return newClientId;

                Fn_HandleReset();      // Clear on success
                if (typeof onPopupCancel === "function") {
                    onPopupCancel({ success: true, message: "Client added successfully!" });
                    return;
                }
                setSnackbar({ open: true, message: "Client added successfully!", severity: 'success' })
                setTimeout(() => { navigate(-1); }, 600);

            } else if (mode === "edit" && id) {
                await axios.put(`${path}/client/Update/${id}`, payload);
                // setTimeout(() => { navigate(-1); }, 600);
            }
        } catch (err) {
            console.error("Error saving client:", err);

            // 🟡 VALIDATION ERROR → DO NOTHING
            if (err.message === VALIDATION_ERROR) {
                throw err; // just propagate
            }

            // 🔴 REAL API ERROR
            if (err?.response?.status === 400) {
                setFormError("Client already exists.");
            } else {
                setFormError(
                    `Failed to ${mode === "add" ? "add" : "update"} client. Please try again.`
                );
            }
            throw err; // 🔥 rethrow
        }
    };

    const submitAllConsignees = async (clientId) => {
        if (!tempConsignees.length) return;

        await Promise.all(
            tempConsignees.map(row => {
                const { ConID, isTemp, ...rest } = row;
                console.log(row)
                return axios.post(`${path}/api/consignee/insert`, { ...rest, PartyID: id ?? clientId, companyId, userId, AppRegID });
            })
        );
    };

    const submitAllPartyWiseItems = async (clientId) => {
        if (!tempPartyWiseItems.length) return;

        const fYearPWI = getCurrentFYear();
        const AppRegIDPWI = AppRegID;
        const GCompIDPWI = selectedCompany?.GCompId;
        const BranchIdPWI = selectedCompany?.BranchId;

        const payload = {
            partyId: id ?? clientId,
            items: tempPartyWiseItems.map(row => ({
                PartyWiseRateID: row.PartyWiseRateID || null,
                ItemID: row.ItemID,
                SaleRate: row.SaleRate,
                PurchaseRate: row.PurchaseRate,
                Disc: row.Disc,
            })),
            companyId,
            AppRegID: AppRegIDPWI,
            GCompID: GCompIDPWI,
            userId,
            BranchId: BranchIdPWI,
            fYear: fYearPWI,
        };

        await axios.post(`${path}/api/partywise/saveRates`, payload);
    };

    const submitAllGroupWiseItems = async (clientId) => {
        if (!tempGroupWiseItems.length) return;

        const fYearGWI = getCurrentFYear();
        const AppRegIDGWI = AppRegID;
        const GCompIDGWI = selectedCompany?.GCompId;
        const BranchIdGWI = selectedCompany?.BranchId;

        const payload = {
            partyId: id ?? clientId,
            items: tempGroupWiseItems.map(row => ({
                GroupWiseRateID: row.GroupWiseRateID || null,
                ProdGRPID: row.ProdGRPID,
                Disc: row.Disc,
            })),
            companyId,
            AppRegID: AppRegIDGWI,
            GCompID: GCompIDGWI,
            userId,
            BranchId: BranchIdGWI,
            fYear: fYearGWI,
        };

        await axios.post(`${path}/api/groupwise/saveRates`, payload);
    };

    const handleFinalSubmit = async (e) => {
        e?.preventDefault?.();
        const requiredAction = mode === "edit" ? "edit" : "add";
        if (canAccess && !canAccess("Account", requiredAction)) {
            showAccessDenied?.();
            return;
        }

        // ── Check GST duplicate before saving ──
        if (gstNo) {
            try {
                const dupRes = await axios.get(`${path}/client/check-gst-firmname`, {
                    params: { companyId, gstNo, firmName: companyName, id: id || null }
                });
                if (dupRes.data?.exactDuplicate) {
                    setFormError("Client already exists with the same GST Number and Company Name.");
                    setSnackbar({ open: true, severity: "error", message: "Client already exists with the same GST Number and Company Name." });
                    return;
                }
                if (dupRes.data?.gstDuplicate) {
                    setGstDuplicateConfirmOpen(true);
                    return;
                }
            } catch (err) {
                console.error("GST duplicate check failed:", err);
                // fall through and continue with save if the check itself fails
            }
        }

        await proceedWithSave();
    };

    const proceedWithSave = async () => {
        setIsFinalSubmitting(true);

        let clientId;

        /* ================= CLIENT SAVE ================= */
        try {
            clientId = await Fn_HandleSubmit();   // client insert/update  // ✅ get ID
        } catch (err) {
            console.error("Client save failed", err);

            // ❌ DO NOT show snackbar for validation errors
            if (err.message === VALIDATION_ERROR) {
                setIsFinalSubmitting(false);
                return;
            }

            // ✅ Only API errors show snackbar
            setSnackbar({ open: true, severity: "error", message: err?.response?.data?.message || "Failed to save client details" });
            setIsFinalSubmitting(false);
            return;
        }

        /* ================= CONSIGNEE SAVE ================= */
        try {
            await submitAllConsignees(clientId);  // ✅ use ID
        } catch (err) {
            console.error("Consignee save failed", err);

            setSnackbar({ open: true, severity: "error", message: err?.response?.data?.message || "Client saved, but failed to save consignee details" });
            setIsFinalSubmitting(false);
            return; // ❗ STOP HERE
        }

        /* ================= PARTYWISE ITEM RATE SAVE ================= */
        try {
            await submitAllPartyWiseItems(clientId);  // ✅ use ID
        } catch (err) {
            console.error("Partywise item rate save failed", err);

            setSnackbar({ open: true, severity: "error", message: err?.response?.data?.message || "Client saved, but failed to save partywise item rates" });
            setIsFinalSubmitting(false);
            return; // ❗ STOP HERE
        }

        /* ================= GROUPWISE DISC SAVE ================= */
        try {
            await submitAllGroupWiseItems(clientId);  // ✅ use ID
        } catch (err) {
            console.error("Groupwise disc save failed", err);

            setSnackbar({ open: true, severity: "error", message: err?.response?.data?.message || "Client saved, but failed to save groupwise discounts" });
            setIsFinalSubmitting(false);
            return; // ❗ STOP HERE
        }

        /* ================= SUCCESS ================= */
        setSnackbar({ open: true, severity: "success", message: mode === "add" ? "Client added successfully!" : "Client updated successfully!" });


        if (typeof onPopupCancel === "function") {
            onPopupCancel()
        } else {
            setTimeout(() => navigate(-1), 600);
        }


        Fn_HandleReset();  // NOW reset
    };

    const handleCancel = () => {
        Fn_HandleReset();
        if (typeof onPopupCancel === "function") {
            onPopupCancel();
        } else {
            navigate(-1);
        }
    };

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                if (!isCategoryDuplicate && !isFinalSubmitting) {
                    handleFinalSubmit();
                }
            } else if (e.code === "KeyC") {
                e.preventDefault();
                handleCancel();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    // ------------------ Handle Percentage Input ------------------
    const handlePercentageInput = (value, setter) => {
        let val = value.trim();
        if (val.startsWith("-")) return;    // Disallow negative signs
        val = val.replace(/[^0-9.]/g, '');  // Allow only digits and one decimal point
        const parts = val.split('.');   // Prevent multiple decimals
        if (parts.length > 2) return;
        if (parts[1]?.length > 2) return;   // Enforce only two digits after decimal
        if (parseInt(parts[0]) > 100) return;   // Enforce if integer part is 100, decimal must be 00 or empty
        if (parseInt(parts[0]) === 100 && parts[1] && parts[1] !== '00') return;
        setter(val);
    };
    // ------------------ Open popup ------------------ 
    const handleOpenPopup = () => { setOpenPopup(true); };
    // ------------------ Handle business card data from popup ------------------ 
    const handleSaveBusinessCard = (data) => {
        setCompanyName(data.companyName || "");
        setContactPerson(data.contactPersonName1 || "");
        setMobileNo(data.mobileNumber1 || "");
        setAlternateMobile(data.mobileNumber2 || "");
        setEmailId(data.email1 || "");
        setAlternateEmailId(data.email2 || "");
        setWebsite(data.websiteUrl || "");
        setAddress(data.address || "");
        setPinCode(data.pincode || "");
        if (data.pincode) {
            const matchingCity = cities.find(c => c.pincode === data.pincode);
            if (matchingCity) {
                setCity(matchingCity.city || "");
                setStateField(matchingCity.state || "");
                setStateCode(matchingCity.stateCode || "");
                setCountry(matchingCity.country || "");
                setStateValue({ stateName: matchingCity.state, stateCode: matchingCity.stateCode });
                setStateInputValue(`${matchingCity.state} (${matchingCity.stateCode})`);
            } else {
                setCity("");
                setStateField("");
                setStateCode("");
                setCountry("");
                setStateValue(null);
                setStateInputValue("");
            }
        } else {
            setCity("");
            setStateField("");
            setStateCode("");
            setCountry("");
            setStateValue(null);
            setStateInputValue("");
        }
    };
    // ------------------ OCR handlers ------------------ 
    const handleTextExtracted = (text) => {
        const lines = text.split('\n').map(line => line.trim()).filter(line => line.length > 0);
        setExtractedTextLines(lines);
        setIsProcessing(false);
    };
    const handleDataUpdate = (data) => { setBusinessCardData(data); };
    const handleStartProcessing = () => { setIsProcessing(true); };
    const handleTextLinesUpdate = (lines) => { setExtractedTextLines(lines); };
    // ------------------ Close popup ------------------ 
    const handleClosePopup = () => {
        setOpenPopup(false);
        setOpenCamera(false);
        setExtractedTextLines([]);
        setBusinessCardData({ companyName: "", contactPersonName1: "", contactPersonName2: "", mobileNumber1: "", mobileNumber2: "", email1: "", email2: "", websiteUrl: "", address: "", pincode: "" });
    };
    return (
        <>
            <Paper elevation={3} sx={{
                p: 3, pt: 1, mt: 1, mx: { xs: 0, sm: 3, md: "auto" }, maxWidth: 900,
                boxShadow: {
                    xs: onPopupCancel ? "none" : "none", // xs pe always none
                    sm: onPopupCancel ? "none" : "0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)"
                }
            }}>

                <Box component="form" noValidate sx={{ overflowY: { sm: "hidden", md: "visible" }, maxHeight: { sm: "none" } }} onSubmit={handleFinalSubmit}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                        }
                    }}
                >
                    <Box sx={{ position: 'relative' }}>
                        {/* Back arrow — mobile/tablet only */}
                        <IconButton onClick={handleCancel} sx={{ position: 'absolute', left: 0, display: { xs: 'flex', md: 'none' }, color: 'text.secondary', p: 0.5, }} >
                            <ArrowBackIcon fontSize="small" />
                        </IconButton>
                        <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mb: 1 }}>
                            {mode === 'add' ? 'Add New Account' : 'Edit Account'}
                        </Typography>
                        <Box sx={{ position: 'absolute', top: 0, right: 0, zIndex: 10, display: 'flex', gap: 1 }}>
                            {/* Excel Import Icon - Redirects to /insertclient */}
                            {/* Hidden in the popup: it would navigate away from the form that opened it */}
                            {!onPopupCancel && (
                                <Tooltip title="Bulk Import Clients">
                                    <IconButton variant="contained" onClick={() => navigate("/main/insertClient")} sx={{ width: { xs: 30, sm: 34 }, height: { xs: 30, sm: 34 }, bgcolor: 'green', color: 'white', '&:hover': { bgcolor: 'primary.dark' }, boxShadow: 3 }} >
                                        <FaFileExcel />
                                    </IconButton>
                                </Tooltip>
                            )}


                            {/* Camera Icon - Original OCR */}
                            {/* <Tooltip title="Scan Business Card">
                            <IconButton onClick={handleOpenPopup} sx={{ width: 34, height: 34, bgcolor: 'primary.main', color: 'white', '&:hover': { bgcolor: 'primary.dark' }, boxShadow: 3 }} >
                                <CameraEnhanceOutlined sx={{ fontSize: 24 }} />
                            </IconButton>
                        </Tooltip> */}
                        </Box>
                    </Box>
                    <Divider sx={{ mb: 1 }} />
                    <Box display="flex" flexWrap="wrap" gap={2}>
                        {/* ───── LEFT COLUMN ───── */}
                        <Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 2 }}>
                            {/* GST */}
                            <Box sx={{ position: "relative" }}>

                                <TextField label="GST No." fullWidth size="small" value={gstNo} error={Boolean(gstError)} helperText={gstError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Button variant="outlined" size="small" onClick={handleGstAutoFill} disabled={gstLookupLoading || gstNo.length !== 15} sx={{ height: 32, mr: -1, fontSize: '0.75rem', textTransform: 'none', padding: '4px 8px' }} >
                                                    {gstLookupLoading ? <CircularProgress size={16} sx={{ mr: 0.5 }} /> : 'Verify'}
                                                </Button>
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={(e) => {
                                        const val = e.target.value.toUpperCase();
                                        if (/^[0-9A-Z]*$/.test(val) && val.length <= 15) {
                                            setGstNo(val);
                                            const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                                            if (!val) {
                                                setGstError("");
                                                setGstValid(null);
                                            } else if (!gstRegex.test(val)) {
                                                setGstError("Invalid pattern");
                                                setGstValid(false);
                                            } else {
                                                setGstError("");
                                                setGstValid(true);
                                            }
                                        }
                                    }}
                                />
                                {gstLookupLoading && (<CircularProgress size={24} sx={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", }} />)}
                            </Box>
                            {gstStatus && gstStatus !== "Active" && (
                                <Typography variant="caption" sx={{ mt: -1.5, color: "error.main", display: "block", }} >
                                    GST Status: {gstStatus}
                                </Typography>
                            )}
                            <TextField label="Company Name" fullWidth size="small" required value={toProperCase(companyName)} onChange={(e) => setCompanyName(toProperCase(e.target.value))} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                            {/* <DropdownProductCodeClientMaster
                                id="productCode"
                                connectionString={connectionString}
                                companyId={companyId}
                                AppRegID={AppRegID}
                                value={selectedProduct?.itemCode || ''}
                                onSelect={(option) => setSelectedProduct(option)}
                                label="Product Code"
                                searchBy="code"
                            /> */}
                            <Box>
                                {/* <AccGroupSelect groups={accGroups} value={selectedAccGrpId} loading={isLoadingAccGrp} onAddNew={() => setOpenAccGrpPopup(true)}
                                    onChange={(id, name) => {
                                        setSelectedAccGrpId(id ?? '');
                                        setSelectedAccGrpName(name ?? '');
                                    }}
                                /> */}
                                <AccGroupSelect
                                    groups={accGroups}
                                    value={selectedAccGrpId}
                                    loading={isLoadingAccGrp}
                                    required
                                    error={Boolean(accGrpError)}
                                    helperText={accGrpError}
                                    onAddNew={() => setOpenAccGrpPopup(true)}
                                    onChange={(id, name) => {
                                        setSelectedAccGrpId(String(id ?? ''));
                                        setSelectedAccGrpName(String(name ?? ''));
                                        // GrpHead != 3 → Op. Bal. not allowed, clear any entered value
                                        if (!isGrpHeadThree(id)) setOpBal("");
                                        setAccGrpError("");
                                        setFormError("");
                                    }}
                                />
                            </Box>
                            {/* Client Category Dropdown */}
                            {/* <FormControl fullWidth size="small">
                            <InputLabel id="client-category-label">Client Category</InputLabel>
                            <Select labelId="client-category-label" label="Client Category" value={clientCategory} onChange={(e) => setClientCategory(e.target.value)} >
                                <MenuItem value="" disabled>
                                    Select Client Category
                                </MenuItem>
                                {clientCategoryOptions.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.display}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}
                            {/* <TextField label="Client Code" fullWidth size="small" inputProps={{ maxLength: 6 }} value={clientCode} onChange={(e) => setClientCode(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} /> */}
                            <Box flex={1}>
                                <Dropdown required label="Category" value={category} options={categoryOptions} valueKey="id" labelKey="value" placeholder="Select a category" disabled={mode === "edit" && category !== 0}
                                    // onChange={(option) => setCategory(option)}
                                    // onChange={(option) => setCategory(option.id)}
                                    onChange={async (option) => {
                                        setCategory(option.id);
                                        try {
                                            const res = await axios.get(`${path}/client/check-category`, { params: { companyId, categoryId: option.id, id: id || null } });
                                            if (res.data?.duplicate) {
                                                setFormError("This category already exists.");
                                                setcategoryError("This category already exists.");
                                                setIsCategoryDuplicate(true);  // ✅ ADD THIS
                                            } else {
                                                setFormError("");
                                                setcategoryError("");
                                                setIsCategoryDuplicate(false);  // ✅ ADD THIS
                                            }
                                        } catch (err) {
                                            if (err.response?.status === 400) {
                                                setFormError("This category already exists.");
                                                setcategoryError("This category already exists.");
                                                setIsCategoryDuplicate(true);  // ✅ ADD THIS
                                            } else {
                                                console.error("Category validation failed", err);
                                                setIsCategoryDuplicate(false);  // ✅ ADD THIS
                                            }
                                        }
                                    }}
                                />
                                {Errorcategory ? (
                                    <Typography style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                                        {Errorcategory}
                                    </Typography>
                                ) : null}
                            </Box>
                            <TextField label="Address" fullWidth size="small" multiline minRows={3.2} value={toProperCase(address)} onChange={(e) => setAddress(toProperCase(e.target.value))} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38, }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 2px', minHeight: '80px', }, }} />

                            <Box display="flex" gap={1}>
                                <TextField label="Area" size="small" value={toProperCase(area)} error={Boolean(areaError)} helperText={areaError} sx={{ flex: 2, '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onBlur={(e) => { const v = e.target.value.trim(); }}
                                    onChange={(e) => {
                                        setArea(toProperCase(e.target.value));
                                        if (areaError) setAreaError("");
                                    }}
                                />
                                <TextField label="Pincode" size="small" inputProps={{ maxLength: 6 }} value={pinCode} error={Boolean(pinCodeError)} helperText={pinCodeError} sx={{ flex: 1, '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        const pinRegex = /^\d{6}$/;
                                        if (!pinRegex.test(value)) {
                                            setPinCodeError("Invalid pin code");
                                        } else {
                                            setPinCodeError("");
                                        }
                                    }}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "");
                                        setPinCode(val);
                                    }}
                                />
                                <TextField sx={{ flex: 1.5, '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} label="Distance (km)" size="small" type="text" value={distance} error={Boolean(distanceError)} helperText={distanceError}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/[^0-9.]/g, "");
                                        // Allow only one decimal point
                                        const decimalCount = (val.match(/\./g) || []).length;
                                        if (decimalCount > 1) return;
                                        setDistance(val);
                                        // Inline validation
                                        const distRegex = /^\d*\.?\d+$/;
                                        if (!val) {
                                            setDistanceError("");
                                        } else if (!distRegex.test(val)) {
                                            setDistanceError("Enter a positive distance");
                                        } else {
                                            setDistanceError("");
                                        }
                                    }}
                                />
                            </Box>
                            <Box display="flex" gap={1}>
                                {/* Conditional Row: State and State Code */}
                                <Box flex={1}>
                                    <CitySearchInput value={toProperCase(city)} cities={cities} fullWidth required={false} connectionString={connectionString} forceShowDropdown={forceShowCityDropdown} validationStatus={cityValidationStatus} showWarning={!cityValidationStatus.isValid}
                                        onSelectCity={(c) => {
                                            setCity(c.city);
                                            setStateField(c.state);
                                            setStateCode(c.stateCode);
                                            setCountry(c.country);

                                            // ⭐ CLEAR WARNING WHEN USER SELECTS A CITY
                                            setCityValidationStatus({ isValid: true, missingCityState: null, message: "" });
                                            setForceShowCityDropdown(false);  // ⭐ CLOSE DROPDOWN

                                            setCityError("");
                                            setStateError("");
                                            setStateCodeError("");
                                            setCountryError("");
                                        }}
                                    />
                                    {cityError && (
                                        <Typography variant="caption" color="error">
                                            {cityError}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                            <Box display="flex" gap={1}>
                                {/* State - 66% of the row (i.e., 2/3) */}
                                <Box flex={0.5}> <TextField label="State" name="state" value={toProperCase(stateField)} size="small" disabled error={Boolean(stateError)} helperText={stateError} fullWidth sx={{ '& .MuiInputBase-root': { height: 38, }, '& .MuiInputLabel-root': { lineHeight: '1.2em', }, }} /> </Box>
                                {/* State Code - 33% of the row (i.e., 1/3) */}
                                <Box flex={0.2}> <TextField label="State Code" name="stateCode" value={stateCode} size="small" disabled error={Boolean(stateCodeError)} helperText={stateCodeError} fullWidth sx={{ '& .MuiInputBase-root': { height: 38, }, '& .MuiInputLabel-root': { lineHeight: '1.2em', }, }} /> </Box>
                                <Box flex={0.3}> <TextField label="Country" fullWidth size="small" disabled value={toProperCase(country)} onChange={(e) => setCountry(e.target.value)} error={Boolean(countryError)} helperText={countryError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} /> </Box>
                            </Box>
                        </Box>
                        {/* ───── RIGHT COLUMN ───── */}
                        <Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 2 }}>
                            <TextField label="Contact Person" fullWidth size="small" value={toProperCase(contactPerson)} onChange={(e) => setContactPerson(toProperCase(e.target.value))} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                            <Box display="flex" gap={1}>
                                <TextField label="Mobile No." fullWidth size="small" inputProps={{ maxLength: 10 }} value={mobileNo} error={Boolean(mobileError)} helperText={mobileError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "");
                                        setMobileNo(val);
                                        if (!val) {
                                            setMobileError("");
                                        } else if (!/^\d{10}$/.test(val)) {
                                            setMobileError("Invalid mobile No");
                                        } else {
                                            setMobileError("");
                                        }
                                    }}
                                />
                                <TextField label="Alternate Mobile No." fullWidth size="small" inputProps={{ maxLength: 10 }} value={alternateMobile} error={Boolean(alternateMobileError)} helperText={alternateMobileError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "");
                                        setAlternateMobile(val);
                                        if (!val) {
                                            setAlternateMobileError("");
                                        } else if (!/^\d{10}$/.test(val)) {
                                            setAlternateMobileError("Invalid mobile No");
                                        } else {
                                            setAlternateMobileError("");
                                        }
                                    }}
                                />
                            </Box>
                            <TextField label="Website" fullWidth size="small" value={website} error={Boolean(websiteError)} helperText={websiteError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setWebsite(val);
                                    const webRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\/.*)?$/;
                                    if (!val) {
                                        setWebsiteError("");
                                    } else if (!webRegex.test(val)) {
                                        setWebsiteError("Invalid website URL");
                                    } else {
                                        setWebsiteError("");
                                    }
                                }}
                            />
                            <Grid container spacing={1}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <Box sx={{ position: "relative" }}>
                                        <TextField label="Email Id" fullWidth size="small" type="email" value={emailId} error={Boolean(emailIdError)} helperText={emailIdError} sx={{ "& .MuiInputBase-root": { height: 38, borderRadius: 2, }, "& .MuiInputBase-input": { padding: "10px 14px", }, }} onFocus={() => setShowEmailSuggestions(true)}
                                            onChange={(e) => {
                                                setEmailId(e.target.value);
                                                setEmailIdError(""); // clear error while typing
                                            }}
                                            onBlur={(e) => {
                                                const val = e.target.value.trim();
                                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                // ⏳ delay so click on suggestion works
                                                setTimeout(() => {
                                                    setShowEmailSuggestions(false);

                                                    if (!val) {
                                                        setEmailIdError("");
                                                    } else if (!emailRegex.test(val)) {
                                                        setEmailIdError("Invalid email format");
                                                    } else {
                                                        setEmailIdError("");
                                                    }
                                                }, 150);
                                            }}
                                        />

                                        {/* 🔹 Tooltip-like email suggestions */}
                                        {showEmailSuggestions && (
                                            <Box sx={{ position: "absolute", top: "calc(100% + 8px)", left: 12, bgcolor: themeColors.neutral.surface, borderRadius: 2, px: 1, py: 0.5, zIndex: 20, boxShadow: "0px 6px 18px rgba(0,0,0,0.15)", minWidth: 260, }} >
                                                {/* Arrow */}
                                                <Box sx={{ position: "absolute", top: -6, left: 16, width: 12, height: 12, bgcolor: themeColors.neutral.surface, transform: "rotate(45deg)", boxShadow: "-2px -2px 4px rgba(0,0,0,0.04)", }} />

                                                {EMAIL_SUGGESTIONS
                                                    .filter((item) => !emailId || item.toLowerCase().includes(emailId.toLowerCase()))
                                                    .map((item) => (
                                                        <Box key={item} sx={{ px: 1.5, py: 0.75, fontSize: 13, borderRadius: 1, cursor: "pointer", whiteSpace: "nowrap", "&:hover": { backgroundColor: "#f0f4ff", }, }}
                                                            onMouseDown={() => {
                                                                // 👈 onMouseDown is IMPORTANT
                                                                setEmailId(item);
                                                                setEmailIdError("");
                                                            }}
                                                        >
                                                            {item}
                                                        </Box>
                                                    ))}
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <TextField label="Alternate Email Id" fullWidth size="small" type="email" value={alternateEmailId} error={Boolean(alternateEmailIdError)} helperText={alternateEmailIdError} onChange={(e) => setAlternateEmailId(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                        onBlur={(e) => {
                                            const val = e.target.value.trim();
                                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                            if (!val) {
                                                setAlternateEmailIdError("");
                                            } else if (!emailRegex.test(val)) {
                                                setAlternateEmailIdError("Invalid email format");
                                            } else {
                                                setAlternateEmailIdError("");
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Box display='flex' gap={1}>
                                <TextField label="PAN No." fullWidth size="small" inputProps={{ maxLength: 10 }} value={panNo} error={Boolean(panError)} helperText={panError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onChange={(e) => {
                                        const val = e.target.value.toUpperCase();
                                        setPanNo(val);
                                        // Inline PAN validation
                                        if (!val) {
                                            setPanError("");
                                        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(val)) {
                                            setPanError("Invalid PAN No");
                                        } else {
                                            setPanError("");
                                        }
                                    }}
                                />
                                <TextField label="Aadhar No." fullWidth size="small" inputProps={{ maxLength: 12 }} value={aadharNo} error={Boolean(aadharError)} helperText={aadharError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "");
                                        setAadharNo(val);
                                        // Inline validation logic
                                        if (!val) {
                                            setAadharError("");
                                        } else if (!/^\d{12}$/.test(val)) {
                                            setAadharError("Invalid Aadhar No");
                                        } else {
                                            setAadharError("");
                                        }
                                    }}
                                />
                            </Box>
                            <Box display='flex' gap={1}>
                                <TextField label="MSME No." fullWidth size="small" value={msmeNo} helperText={msmeError} error={Boolean(msmeError)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onChange={(e) => {
                                        const val = e.target.value.toUpperCase();
                                        setMsmeNo(val);
                                        if (val && !/^[A-Z0-9-]+$/.test(val)) {
                                            setMsmeError("Only letters, numbers or hyphens allowed");
                                        } else {
                                            setMsmeError("");
                                        }
                                    }}
                                />
                                <TextField label="Transporter" fullWidth size="small" value={transporter} onChange={(e) => setTransporter(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                            </Box>
                            <Box display='flex' gap={1}>
                                <TextField label="Agent Name" fullWidth size="small" value={agentName} onChange={(e) => setAgentName(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                                <TextField label="Agent Commission (%)" fullWidth size="small" value={agentComm} error={Boolean(agentCommError)} helperText={agentCommError} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        // Use helper to format and restrict input
                                        handlePercentageInput(val, (cleanVal) => {
                                            setAgentComm(cleanVal);

                                            // Inline validation
                                            if (!cleanVal) {
                                                setAgentCommError("");
                                            } else {
                                                const num = parseFloat(cleanVal);
                                                if (isNaN(num) || num <= 0 || num > 100 || (num === 100 && cleanVal !== "100" && cleanVal !== "100.00")) {
                                                    setAgentCommError("Commission must be between 1–100%");
                                                } else {
                                                    setAgentCommError("");
                                                }
                                            }
                                        });
                                    }}
                                />
                            </Box>

                            {/* Payment Days | Credit Limit | Interest | Disc | Op.Bal — all in one flex row */}
                            <Box display="flex" gap={1} flexWrap="wrap">

                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <TextField
                                        label="Payment Days"
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 10 }}
                                        value={paymentTerms}
                                        onChange={(e) => {
                                            const onlyDigits = e.target.value.replace(/\D/g, '');
                                            setPaymentTerms(onlyDigits);
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }}
                                    />
                                </Box>

                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <TextField
                                        label="Credit Limit"
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 13, inputMode: 'decimal' }}
                                        value={creditLimit}
                                        onChange={(e) => {
                                            // DECIMAL(10,2): digits only, at most one decimal point,
                                            // at most 2 digits after it.
                                            let v = e.target.value.replace(/[^0-9.]/g, '');
                                            const firstDot = v.indexOf('.');
                                            if (firstDot !== -1) {
                                                v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
                                                const [intPart, decPart] = v.split('.');
                                                v = decPart != null ? `${intPart}.${decPart.slice(0, 2)}` : intPart;
                                            }
                                            setCreditLimit(v);
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }}
                                    />
                                </Box>

                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <TextField
                                        label="Interest"
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 10 }}
                                        value={interest}
                                        onChange={(e) => handlePercentageInput(e.target.value, setInterest)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }}
                                    />
                                </Box>

                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <TextField
                                        label="Disc.(%)"
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 6 }}
                                        value={disc}
                                        onChange={(e) => handlePercentageInput(e.target.value, setDisc)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }}
                                    />
                                </Box>


                            </Box>
                                <Box display="flex" gap={1} alignItems="flex-end" justifyContent="space-between">
                                <Box sx={{ width: 200, minWidth: 200 }}>
                                    <TextField
                                        label="Op. Bal."
                                        fullWidth
                                        size="small"
                                        type="number"
                                        inputProps={{ step: "0.01" }}
                                        value={opBal}
                                        disabled={isOpBalDisabled}
                                        onChange={(e) => {
                                            setOpBal(e.target.value);
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }}
                                    />
                                </Box>

                                    <TextField
                                        label="Disc1.(%)"
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 6 }}
                                        value={disc1}
                                        onChange={(e) => handlePercentageInput(e.target.value, setDisc1)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }}
                                    />

                                    <TextField
                                        label="Disc2.(%)"
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 6 }}
                                        value={disc2}
                                        onChange={(e) => handlePercentageInput(e.target.value, setDisc2)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                        }}
                                    />
                                </Box>

                        </Box>
                    </Box>
                    <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, border: `1px solid ${themeColors.neutral.line}`, display: "flex", justifyContent: "space-between", alignItems: "center", background: themeColors.neutral.surfaceAlt }} >
                        <Typography fontWeight={600}>
                            Consignee Management
                        </Typography>

                        <Button variant={showConsignee ? "outlined" : "contained"} size="small" onClick={() => setShowConsignee(prev => !prev)} >
                            {showConsignee ? "Close" : "Add / Manage"}
                        </Button>
                    </Box>
                    <Box>
                        <Collapse in={showConsignee} timeout="auto" unmountOnExit>
                            <Paper elevation={2} sx={{ mt: 2, p: 2, mx: { xs: 0 }, borderRadius: 2, border: `1px solid ${themeColors.neutral.line}`, background: themeColors.neutral.surface }} >
                                <ClientConsigneeMaster
                                    onBack={() => setShowConsignee(false)}
                                    connectionString={connectionString}
                                    clientId={id}
                                    clientFirmName={companyName}
                                    mode="add"
                                    activeViewHandler={() => setShowConsignee(false)}
                                    tempRows={tempConsignees}
                                    setTempRows={setTempConsignees}
                                    isFinalSubmitting={isFinalSubmitting}
                                />
                            </Paper>
                        </Collapse>
                        {/* )} */}
                    </Box>

                    {mode === "edit" && id && (
                        <>
                            <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, border: `1px solid ${themeColors.neutral.line}`, display: "flex", justifyContent: "space-between", alignItems: "center", background: themeColors.neutral.surfaceAlt }} >
                                <Typography fontWeight={600}>
                                    Partywise Item Rate
                                </Typography>

                                <Button variant={openPartyWiseDialog ? "outlined" : "contained"} size="small" onClick={() => setOpenPartyWiseDialog(prev => !prev)} >
                                    {openPartyWiseDialog ? "Close" : "Add / Manage"}
                                </Button>
                            </Box>
                            <Box>
                                <Collapse in={openPartyWiseDialog} timeout="auto" unmountOnExit>
                                    <Paper elevation={2} sx={{ mt: 2, p: 2, mx: { xs: 0 }, borderRadius: 2, border: `1px solid ${themeColors.neutral.line}`, background: themeColors.neutral.surface }} >
                                        <PartyWiseItemDialog
                                            inline
                                            open={openPartyWiseDialog}
                                            onClose={() => setOpenPartyWiseDialog(false)}
                                            partyId={id}
                                            partyName={companyName}
                                            connectionString={connectionString}
                                            tempRows={tempPartyWiseItems}
                                            setTempRows={setTempPartyWiseItems}
                                            isFinalSubmitting={isFinalSubmitting}
                                        />
                                    </Paper>
                                </Collapse>
                            </Box>

                            <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, border: `1px solid ${themeColors.neutral.line}`, display: "flex", justifyContent: "space-between", alignItems: "center", background: themeColors.neutral.surfaceAlt }} >
                                <Typography fontWeight={600}>
                                    Groupwise Disc
                                </Typography>

                                <Button variant={showGroupWiseDisc ? "outlined" : "contained"} size="small" onClick={() => setShowGroupWiseDisc(prev => !prev)} >
                                    {showGroupWiseDisc ? "Close" : "Add / Manage"}
                                </Button>
                            </Box>
                            <Box>
                                <Collapse in={showGroupWiseDisc} timeout="auto" unmountOnExit>
                                    <Paper elevation={2} sx={{ mt: 2, p: 2, mx: { xs: 0 }, borderRadius: 2, border: `1px solid ${themeColors.neutral.line}`, background: themeColors.neutral.surface }} >
                                        <GroupWiseDiscMaster
                                            partyId={id}
                                            partyName={companyName}
                                            connectionString={connectionString}
                                            tempRows={tempGroupWiseItems}
                                            setTempRows={setTempGroupWiseItems}
                                            isFinalSubmitting={isFinalSubmitting}
                                        />
                                    </Paper>
                                </Collapse>
                            </Box>
                        </>
                    )}

                    {/* ─────────────── FORM ERROR MESSAGE ─────────────── */}
                    {formError && (<Typography color="error" align="center" sx={{ mt: 2 }}> {formError} </Typography>)}
                    {/* ─────────────── SAVE / CANCEL BUTTONS ─────────────── */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
                        <Button variant="contained" color="primary" sx={{ minWidth: 120, height: 38 }} type="submit" disabled={isCategoryDuplicate} > {mode === "add" ? "Submit" : "Update"} </Button>
                        <Button variant="contained" color="error" sx={{ minWidth: 120, height: 38 }} onClick={handleCancel}> Cancel </Button>
                    </Box>
                </Box>

                {/* OCR Popup */}
                <Dialog open={openPopup} onClose={handleClosePopup} fullWidth sx={{ zIndex: 1300, '& .MuiDialog-paper': { width: { xs: '98vw', sm: '95vw', md: '85vw', lg: '85vw' }, maxWidth: { xs: '98vw', sm: '95vw', md: '85vw', lg: '1100px' }, maxHeight: { xs: '95vh', sm: '95vh', md: '90vh', lg: '90vh' }, m: { xs: 1, sm: 2 }, borderRadius: { xs: 1, sm: 2 }, }, }} >
                    <DialogContent sx={{ p: { xs: 1, sm: 2, md: 3 }, overflowX: 'hidden', overflowY: 'auto', width: '100%', boxSizing: 'border-box', }} >
                        <Box sx={{ position: 'absolute', top: 15, right: 15 }}>
                            <IconButton onClick={handleClosePopup} sx={{ width: 40, height: 38, bgcolor: 'primary.main', color: 'white', '&:hover': { bgcolor: 'primary.dark' }, boxShadow: 3, }} >
                                <Close sx={{ fontSize: 32 }} />
                            </IconButton>
                        </Box>
                        <Box display="grid" gridTemplateColumns={{ xs: '1fr', sm: '1fr', md: '1fr', lg: '40% 60%' }} gap={{ xs: 1, sm: 1.5, md: 2 }} sx={{ width: '100%', overflowX: 'hidden', '& > *': { minWidth: 0, }, }} >
                            <Box sx={{ width: '100%' }}>
                                <OCRImageCapture onTextExtracted={handleTextExtracted} autoOpenCamera={openCamera} onCloseCamera={() => setOpenCamera(false)} />
                            </Box>
                            {extractedTextLines.length > 0 && (
                                <Box sx={{ width: '100%' }}>
                                    <OCRTextAssignment extractedTextLines={extractedTextLines} businessCardData={businessCardData} onDataUpdate={handleDataUpdate} onTextLinesUpdate={handleTextLinesUpdate} isProcessing={isProcessing} onSaveBusinessCard={handleSaveBusinessCard} onClose={handleClosePopup} />
                                </Box>
                            )}
                        </Box>
                    </DialogContent>
                </Dialog>

                <Dialog open={openAccGrpPopup} maxWidth="sm" fullWidth
                    onClose={(event, reason) => {
                        if (reason === "backdropClick") return;
                        setOpenAccGrpPopup(false);
                        Hlp_Fn_AccUnderGroup();
                    }}
                >
                    <DialogContent>
                        <AccGrpMaster mode="add" connectionString={connectionString} companyId={companyId}
                            onPopupCancel={() => {
                                setOpenAccGrpPopup(false);
                                Hlp_Fn_AccUnderGroup();
                            }}
                        />
                    </DialogContent>
                </Dialog>

                {/* GST duplicate confirmation */}
                <Dialog open={gstDuplicateConfirmOpen} onClose={() => setGstDuplicateConfirmOpen(false)} maxWidth="xs" fullWidth>
                    <Box sx={{ height: 4, background: `linear-gradient(90deg, #f57c00 0%, ${themeColors.warning.main} 100%)` }} />
                    <DialogTitle sx={{ color: 'warning.main', fontWeight: 700 }}>Alert</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" sx={{ color: 'warning.main' }}>
                            A client with the same GST Number already exists. Are you really want to save the client?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setGstDuplicateConfirmOpen(false);
                                proceedWithSave();
                            }}
                            variant="contained"
                            color="warning"
                            size="small"
                        >
                            Yes
                        </Button>
                        <Button onClick={() => setGstDuplicateConfirmOpen(false)} variant="outlined" color="inherit" size="small">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Global snackbar for showing API errors */}
                <Snackbar open={snackbar.open} autoHideDuration={1500} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                    <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Paper>
        </>
    );
}